import { render, staticRenderFns } from "./CycleAttributes.vue?vue&type=template&id=37610e12&scoped=true"
import script from "./CycleAttributes.vue?vue&type=script&lang=js"
export * from "./CycleAttributes.vue?vue&type=script&lang=js"
import style0 from "./CycleAttributes.vue?vue&type=style&index=0&id=37610e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37610e12",
  null
  
)

export default component.exports